import ResultsDashboard from '../components/results/ResultsDashboard';

function ResultsPage() {
  return <ResultsDashboard />;
}

export default ResultsPage;
